import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { App } from './App.js';
import { loadConfig } from './config.js';
import './styles.css';

async function bootstrap() {
  const root = createRoot(document.getElementById('root')!);
  try {
    await loadConfig();
    root.render(
      <React.StrictMode>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </React.StrictMode>,
    );
  } catch {
    root.render(<div className="fatal">Could not load app configuration.</div>);
  }
}

void bootstrap();
